import { render, staticRenderFns } from "./groupPullNew.vue?vue&type=template&id=39bcd020&scoped=true&"
import script from "./groupPullNew.vue?vue&type=script&lang=js&"
export * from "./groupPullNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bcd020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bcd020')) {
      api.createRecord('39bcd020', component.options)
    } else {
      api.reload('39bcd020', component.options)
    }
    module.hot.accept("./groupPullNew.vue?vue&type=template&id=39bcd020&scoped=true&", function () {
      api.rerender('39bcd020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dataManage/groupPullNew/groupPullNew.vue"
export default component.exports